import styled from 'styled-components';

export const CookiesContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
`;

export const CookiesContent = styled.div`
  max-width: 1000px;
  margin: 4rem auto;
  padding: 0 2rem;
  
  h1 {
    margin-bottom: 2rem;
    text-align: center;
  }
  
  h2 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    color: #007bff;
  }
  
  p {
    margin-bottom: 1rem;
    line-height: 1.6;
  }
  
  ul {
    margin-bottom: 1rem;
    padding-left: 2rem;
  }
  
  li {
    margin-bottom: 0.5rem;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 2rem;
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  
  th {
    background-color: #f2f2f2;
  }
`;

